module.exports = __webpack_public_path__ + "static/media/right-arrow.3ef6f377.svg";